import { render } from "./Stock.vue?vue&type=template&id=74688c86"
import script from "./Stock.vue?vue&type=script&lang=js"
export * from "./Stock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__